import {
    STATUS_BADGES,
    STATUS_LABELS,
    TYPE_BADGES,
    TYPE_LABELS,
} from './labels';

const PREVIEW_LENGTH = 80;

/**
 * props:
 * - data
 * - onViewClick
 */
function FeedbackRow(props) {
    const message = props.data;
    const preview =
        message.message.length > PREVIEW_LENGTH
            ? `${message.message.slice(0, PREVIEW_LENGTH)}...`
            : message.message;

    return (
        <tr>
            <td>
                <span
                    className={`badge ${TYPE_BADGES[message.type] || 'bg-gray'}`}
                >
                    {TYPE_LABELS[message.type] || message.type}
                </span>
            </td>
            <td>
                {message.user?.name}
                <br />
                <small>{message.user?.email}</small>
            </td>
            <td>{preview}</td>
            <td>
                <span
                    className={`badge ${STATUS_BADGES[message.status] || 'bg-gray'}`}
                >
                    {STATUS_LABELS[message.status] || message.status}
                </span>
            </td>
            <td>{new Date(message.createdAt).toLocaleString()}</td>
            <td>
                <button
                    id={'view' + message.id}
                    type="button"
                    className="btn btn-secondary btn-xs"
                    onClick={props.onViewClick}
                >
                    View
                </button>
            </td>
        </tr>
    );
}

export default FeedbackRow;
